import { useEffect, useRef } from 'react'
import QRCode from 'qrcode'
import { Link } from 'react-router-dom'
import type { ShopSummary } from '../lib/api'
import { buildVietQr, BANKS } from '../lib/vietqr'
import { money } from '../lib/money'

interface Props {
  shop: ShopSummary | null
  amount: number
  code: string
}

export function VietQr({ shop, amount, code }: Props) {
  const canvas = useRef<HTMLCanvasElement>(null)
  const ready = !!shop?.bankBin && !!shop.bankAccountNo

  useEffect(() => {
    if (!ready || !canvas.current || !shop?.bankBin || !shop.bankAccountNo) return

    const payload = buildVietQr({
      bankBin: shop.bankBin,
      accountNo: shop.bankAccountNo,
      amount,
      description: code,
    })

    void QRCode.toCanvas(canvas.current, payload, {
      width: 240,
      margin: 1,
      // Nền trắng cố định: máy quét của ngân hàng đọc mã đen trên trắng,
      // đổi màu theo chủ đề tối là có máy đọc được có máy không.
      color: { dark: '#101614', light: '#ffffff' },
      errorCorrectionLevel: 'M',
    })
  }, [ready, shop, amount, code])

  if (!ready) {
    return (
      <div className="qr-empty">
        <p>Chưa khai tài khoản nhận tiền, nên chưa hiện được mã QR.</p>
        <Link className="btn btn-brand" to="/settings/bank">
          Khai tài khoản ngân hàng
        </Link>
      </div>
    )
  }

  const bank = BANKS.find((b) => b.bin === shop!.bankBin)

  return (
    <div className="qr-box">
      <canvas ref={canvas} className="qr-canvas" aria-label={`Mã VietQR ${money(amount)} đồng`} />
      <div className="qr-info">
        <b>{shop!.bankAccountName ?? shop!.name}</b>
        <span className="num">{shop!.bankAccountNo}</span>
        <span>{bank?.short ?? shop!.bankBin}</span>
      </div>
      <p className="qr-note">
        Mã đã gắn sẵn số tiền <b className="num">{money(amount)}đ</b> và nội dung{' '}
        <b>{code}</b> — khách quét là xong, không phải gõ tay.
      </p>
    </div>
  )
}
